import { Flex, Text } from '@mantine/core';
import { EditableTileContainer } from '@dealstack/frontend/shared/components/EditableTileContainer/EditableTileContainer.tsx';
import React from 'react';
import { GetPersonInvestmentProgrammesRes } from '@dealstack/shared/lib/generated';
import { OverflowBadge } from '@dealstack/frontend/app/pages/Valuations/components/OverflowBadgeList/OverflowBadge.tsx';
import { Link } from 'react-router-dom';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils.ts';
import styled from 'styled-components';
import { TEST_ELEMENT_IDS, makeComplexDataTestId } from '@dealstack/shared/tests/testElementIds';

interface Props {
	mip: GetPersonInvestmentProgrammesRes;
	isLegal: boolean;
	hasEditPermission: boolean;
	onRemove?: (mip: GetPersonInvestmentProgrammesRes) => void;
	dealId: string;
}

const makeMipBadge = (mip: GetPersonInvestmentProgrammesRes) => {
	const badges: string[] = [];

	if (mip.isIssuer) {
		badges.push('Issuer');
	}

	if (mip.isLoanFunder) {
		badges.push('Loan Funder');
	}

	if (mip.isPivSource) {
		badges.push('PIV');
	}

	return badges;
};

const StyledLink = styled(Link)`
	&:hover {
		* {
			color: ${(props) => props.theme.v3.colors.blue[6]};
			text-decoration: underline;
		}
	}
`;

export const MipTile = ({ dealId, mip, isLegal, onRemove, hasEditPermission }: Props) => {
	const badges = makeMipBadge(mip);
	return (
		<EditableTileContainer
			hasEditPermission={!isLegal && hasEditPermission}
			onDeleteClick={() => onRemove?.(mip)}
			dataTestId={makeComplexDataTestId(
				TEST_ELEMENT_IDS.CAP_INVESTMENT_PROGRAMMES_ROW,
				mip.id
			)}
			deleteBtnDataTestId={makeComplexDataTestId(
				TEST_ELEMENT_IDS.CAP_INVESTMENT_PROGRAMMES_ROW_UNLINK_BUTTON,
				mip.id
			)}
		>
			<Flex direction="column" gap="0.25rem">
				<StyledLink to={mipManagePath('', { dealId, mipId: mip.id })}>
					<Text
						fw={600}
						c="dark.8"
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_INVESTMENT_PROGRAMMES_ROW_NAME,
							mip.id
						)}
					>
						{mip.programmeName}
					</Text>
				</StyledLink>
				<Flex align="center" gap="0.25rem">
					{badges.map((badge) => (
						<OverflowBadge key={badge} badge={{ id: badge, label: badge }} />
					))}
				</Flex>
			</Flex>
		</EditableTileContainer>
	);
};
